<template>
			<div class="row"> 
				<div class="col-lg-8">
					<section class="checkout-form-sec form-horizontal">
					    <div class="checkout-form-header cart-section-background">
        					<h2 class="checkout-form-sub-heading">Products</h2>
    					</div>
					    <div class="checkout-form-sec-inner cart-top-margin">
							<div v-if="!isLoggedIn || isPreenrollee" class="shiping" style="display:none">
								<label>My Country</label>
								<select v-model="countryCode">
									<option :selected="!countryCode" disabled>Select Country</option>
									<option v-for="code in sortedCountries" :key="code" :value="code" :selected="code == countryCode">{{ countries[code] }}</option>
								</select>
							</div>
							<div class="fill">
								<div v-if="items.length" class="item-cart">
									<div class="cart-items-table">
										<cart-item v-for="product in visibleProducts" 
											:currency-symbol-right="currencySymbolRight" 
											:currency-symbol-left="currencySymbolLeft" 
											:key="product.id + '_' + product.quantity + '_' + product.free"
											:product="product"
        	  		                                                        :membership="membership"
											@changeProduct="changeProduct"
										></cart-item>
									</div>
								</div>
								<cart-notification v-for="(notification, index) in notifications" :key="index"
									:notification="notification">
								</cart-notification>
							</div>
                		</div>
					</section>
				</div>	
				<div class="col-lg-4">
					<section class="checkout-form-sec form-horizontal">
					    <div class="checkout-form-header cart-section-background">
        					<h2 class="checkout-form-sub-heading">Order Summary</h2>
    					</div>
					    <div class="checkout-form-sec-inner">														
							<cart-summary 
								v-if="products.length > 0"
								:currency-symbol-right="currencySymbolRight" 
								:currency-symbol-left="currencySymbolLeft"
                        		                        :minus-currency-symbol-left="minusCurrencySymbolLeft"
								:productCount="productCount"
                        		                        :productFreeCount="productFreeCount"
								:totalPrice="totalPrice"
								:retailTotalPrice="retailTotalPrice"
                                                                :autoTotalPrice="autoTotalPrice"
								:percentOffName="percentOffName"
                                                                :percentRetailSavings="percentRetailSavings"
								:percentSavings="percentSavings"
								:percentOffNameSecond="percentOffNameSecond"
								:percentSavingsSecond="percentSavingsSecond"
                        		                        :isLoggedIn="isLoggedIn"
                        		                        :totalMemberSave="totalMemberSave"
                                                                :totalAutoSave="totalAutoSave"
                        		                        :membership="membership"
                        		                        :scriptName="scriptName"
                        		                        :couponAmount="couponAmount"
                        		                        :enrollerFirst="enrollerFirst"
                        		                        :shippingOrderCount="shippingOrderCount"
                        	 	                        :retailOnly="retailOnly"
                                                                :giftCardAmount="giftCardAmount"
							></cart-summary>
						</div>
					</section>
        		</div>
			</div>
</template>

<script lang="ts">
    import CartItem from './CartItem.vue';
	import CartNotification from './CartNotification.vue'; 
	import CartSummary from './CartSummary.vue';
	import { currencySymbols, euHempCountries } from '../currencySymbols.pl'
	import { countries } from '../countries.pl'

    export default {
        props: {
			productDataJson: String,
			hasEnroller: Boolean,
			isLoggedIn: Boolean,
			isPreenrollee: Boolean,
         scriptName: String,
         openCartInitially: Boolean,
         coupon: Number,
         enrollerFirst: String,
         retailOnly:Number,
         giftCardAmount:Number
            /* products: Array */
        },
        components: {
            'cart-item': CartItem,
		    'cart-notification': CartNotification,
	        'cart-summary': CartSummary,
		},
		watch: {
			countryCode: function(newCountry,oldCountry) {
				if (newCountry && oldCountry) {
					this.countryChangeReload()	
				}
			},
			isOpen: function(isOpen) {
				if (isOpen) {
					jQuery("#myModal2").modal('show')
				} else {
					jQuery("#myModal2").modal('hide')
				}
			}
		},
		data: function () {
			return {
				isOpen: false,
				bvModalIsOpen: false,
				items: [],
				products: [],
				notifications: [],
				totalPrice: '0',
				retailTotalPrice: '0',
                                autoTotalPrice: '0',
				totalBV: 0,
				countryCode: '',
				percentSavings: 0,
                                percentRetailSavings: 0,
				percentOffName: '',
				percentSavingsSecond: 0,
				percentOffNameSecond: '',
				countries,
                                totalMemberSave: '0',
                                totalAutoSave: '0',
                                membership:0,
                                couponAmount:0,
                                shippingOrderCount:0
			}
		},
		methods: {
			countryChangeReload: function() {
				shoppingCart.update({ country: this.countryCode }).then(function () {
					location.reload();
				});
			},
			isSpecialPackSubProduct(id) {
				return /\d+_\d+/.test(id)
			},
			mapItemsToProductMeta: function () {
				let vm = this;
				let products = [];
				let subProducts = []
				let freeCounts = new Map();
				this.items.forEach(function (item) {
					if (item.free) {
						let productId = item.productId.replace("FREE_", "");
                                                if (item.condition) {
                                                   productId = productId.replace("_" + item.condition, "");
                                                }
						freeCounts[productId] = item.quantity;
						item.productId = productId
					}
				});


				this.items.forEach((item) => {
					if (this.isSpecialPackSubProduct(item.productId)) {
						item = {
							...item, 
							isSpecialPackSubProduct: true,
							productId: String(item.productId).match(/\d+_(?<subpid>\d+)/).groups.subpid
						}
					}
					if (vm.productData[item.productId]) {
						let product = {
							'id': item.productId,
							'name': vm.productData[item.productId].name,
							'price': vm.productData[item.productId].price,
                                                        'retailPrice': vm.productData[item.productId].retailPrice,
                                                        'autoPrice': vm.productData[item.productId].autoPrice,
							'bv': vm.productData[item.productId].bv,
							'quantity': item.quantity,
							'free': item.free,
							'freeCount': freeCounts[item.productId],
							'image': vm.productData[item.productId].image,
							'max': parseInt(vm.productData[item.productId].max, 10),
							'product_months': vm.productData[item.productId].product_months,
							'monthly_bv': vm.productData[item.productId].monthly_bv,
							'sale': vm.productData[item.productId].sale,
		   		         	        'saleMessage': vm.productData[item.productId].saleMessage,
							'salePrice': vm.productData[item.productId].salePrice,
							'isSpecialPackMainProduct': vm.productData[item.productId].isSpecialPackMainProduct,
							'isSpecialPackSubProduct': item.isSpecialPackSubProduct,
							'allowAutoship': (this.isLoggedIn && !this.isPreenrollee) && vm.productData[item.productId].allowAutoship,
							'autoship': item.autoship,
                                                        'condition': item.condition,
                                                        'condition_message': item.condition_message,
						};

						if (vm.productData[item.productId].flavor) {
							product['flavor'] = vm.productData[item.productId].flavor;
						}

						if (vm.productData[item.productId].size) {
							product['size'] = vm.productData[item.productId].size;
						}
						if (vm.productData[item.productId].promoCartMessage) {
							product['promoCartMessage'] = vm.productData[item.productId].promoCartMessage;
						}
						if (vm.productData[item.productId].promoCartMessageLine2) {
							product['promoCartMessageLine2'] = vm.productData[item.productId].promoCartMessageLine2;
						}
						products.push(product);
					}
				});

				this.items	
					.map(p => String(p.productId).match(/(?<main>\d+)_(?<sub>\d+)/)?.groups)
					.filter(p => p)
					.map(m => ({
						...m, 
						sub: products.find(({id}) => id == m.sub)
					}))
					.forEach(({main, sub}) => {
						const p = products.find(({id}) => id == main)
						p.specialPackSubProducts = p.specialPackSubProducts
							? p.specialPackSubProducts.concat(sub)
							: [sub]
					})

				this.products = products;
			},
			closeCart: function (e) {
				this.updateShoppingCartCount();
				this.isOpen = false;
			},
			getProducts: async function () {
				let vm = this;

				await shoppingCart.get().then(
					function (data) {
						vm.items = data.shoppingCartDetails || [];
						vm.mapItemsToProductMeta();
						vm.notifications = data.notifications || [];
						vm.totalPrice = Number(data.amount || 0).toFixed(2);
						vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                                vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
						vm.totalBV = data.bv || 0;
						vm.countryCode = data.country;
						vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                                vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
						vm.percentOffName = data.percentOffName
						vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
						vm.percentOffNameSecond = data.percentOffNameSecond
                                    		vm.couponAmount = Number(data.couponAmount || 0).toFixed(2)
                                  		vm.shippingOrderCount =Number(data.shippingOrderCount ||0)
                  		                if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                     		                   vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                     		                   vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);                             
                                                   vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmount ||0).toFixed(2);
                  	    	                }
                                                vm.totalMemberSave = Number(data.totalMemberSave  || 0).toFixed(2);
                                                vm.membership = data.membership || 0;
                                                vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
					}
				);
			},
			changeProduct({
				id: productID, 
				quantity, 
				autoship,
				isSpecialPackMainProduct, 
				specialPackSubProducts
			}) {
				let vm = this;

				Promise.all(
					[productID].concat(
						isSpecialPackMainProduct
							? specialPackSubProducts
								.map(({id}) => `${productID}_${id}`)
							: []
					)
					.map(id => shoppingCart
						.setProduct(id, {quantity, autoship})
					)
				)
				.then(shoppingCart.get)
				.then(data => {
					vm.items = data.shoppingCartDetails || [];
					vm.mapItemsToProductMeta();
					vm.notifications = data.notifications || [];
					vm.totalPrice = Number(data.amount || 0).toFixed(2);
					vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
                                        vm.autoTotalPrice = Number(data.autoAmount || 0).toFixed(2);
					vm.totalBV = data.bv || 0;
					vm.percentSavings = Number(data.percentSavings).toFixed(2)
                                        vm.percentRetailSavings = Number(data.percentRetailSavings).toFixed(2)
					vm.percentOffName = data.percentOffName
					vm.percentSavingsSecond = Number(data.percentSavingsSecond).toFixed(2)
					vm.percentOffNameSecond = data.percentOffNameSecond
                                        vm.couponAmount = Number(data.couponAmount || 0).toFixed(2);
                                        vm.shippingOrderCount =  Number(data.shippingOrderCount || 0)
                                        if (vm.couponAmount>0 && vm.shippingOrderCount >0 && data.amount>0) {
                                           vm.totalPrice = Number(data.amount - vm.couponAmount ||0).toFixed(2);
                                           vm.retailTotalPrice = Number(data.retailAmount - vm.couponAmount ||0).toFixed(2);
                                           vm.autoTotalPrice = Number(data.autoAmount - vm.couponAmount ||0).toFixed(2);
                                        }
                                        vm.totalMemberSave = Number(data.totalMemberSave || 0).toFixed(2);
                                        vm.membership = data.membership || 0;
                                        vm.tax = Number(data.tax || 0).toFixed(2)
                                        vm.totalAutoSave = Number(data.totalAutoSave  || 0).toFixed(2);
				})
				
			},
			// deleteProduct: function ({id: productID, quantity}) {
			// 	let vm = this;

			// 	shoppingCart.deleteFromCart(productID, quantity).then(
            //         function (data) {
			// 			vm.items = data.shoppingCartDetails || [];
			// 			vm.mapItemsToProductMeta();
			// 			vm.notifications = data.notifications || [];
			// 			vm.totalPrice = Number(data.amount || 0).toFixed(2);
			// 			vm.retailTotalPrice = Number(data.retailAmount || 0).toFixed(2);
			// 			vm.totalBV = data.bv || 0;
			// 		}
            //     );
			// },
			// emptyCart: function () {
			// 	let vm = this;

			// 	shoppingCart.clearCart().then(
            //         function (data) {
			// 			vm.items = data.shoppingCartDetails || [];
			// 			vm.mapItemsToProductMeta();
			// 			vm.notifications = data.notifications || [];
			// 			vm.amount = Number(data.amount || 0).toFixed(2);
			// 			vm.totalBV = data.bv || 0;
			// 		}
            //     );
			// },
			openCountryPopup: function () {
				this.closeCart();
				document.getElementById("country-selector-popup").style.display = "flex";
			},
			openBVModal: function () {
				this.bvModalIsOpen = true;;
			},
			closeBVModal: function () {
				this.bvModalIsOpen = false;
			},
			updateShoppingCartCount: function () {
				var openCart = document.getElementById('openCart'),
					openCartMobile = document.getElementById('openCartMobile'),
					className = 'shopping-cart-item-count',
					itemCount = 0;

				itemCount = this.productCount 
            console.log("updating product Counts",this.productCount)
				if (itemCount > 0) {
					if (openCart.getElementsByClassName(className).length == 0) {
						var cartCountSpan = document.createElement('span');
						cartCountSpan.className = className;
						cartCountSpan.textContent = itemCount;
						openCart.appendChild(cartCountSpan);
					} else {
						openCart.getElementsByClassName(className)[0].innerHTML = itemCount;
					}

					 if (openCartMobile.getElementsByClassName(className).length == 0) {
					 	var cartCountSpan = document.createElement('span');
					 	cartCountSpan.className = className;
					 	cartCountSpan.textContent = itemCount;
					 	openCartMobile.appendChild(cartCountSpan);
					 } else {
					 	openCartMobile.getElementsByClassName(className)[0].innerHTML = itemCount;
					 }
				} else {
					if (openCart.getElementsByClassName(className).length > 0) {
						var cartCountSpan = openCart.getElementsByClassName(className)[0]
						
						cartCountSpan.parentNode.removeChild(cartCountSpan);
					}

					if (openCartMobile.getElementsByClassName(className).length > 0) {
					 	var cartCountSpan = openCartMobile.getElementsByClassName(className)[0]
						
					 	cartCountSpan.parentNode.removeChild(cartCountSpan);
					 }
				}
			},
		},
		created: function () {
			// eventBus.$on('itemDeleted', product => {
			// 	this.deleteProduct(product.id, product.quantity);
			// });
			// eventBus.$on('increaseQuantity', product => {
			// 	this.setProductQuantity(product.id, product.quantity);
			// });
			// eventBus.$on('decreaseQuantity', product => {
			// 	this.setProductQuantity(product.id, product.quantity);
			// });
			// eventBus.$on('changeQuantity', product => {
			// 	this.setProductQuantity(product.id, product.quantity);
			// });

		},
        computed: {
			visibleProducts() {
				return this.products
					.filter(p => !p.isSpecialPackSubProduct)
                                        .filter(p => p.quantity>=1)
			},
			sortedCountries() {
				const c = Object.entries(this.countries).filter(([code]) => code != 'US')
				c.sort(([c1,n1],[c2,n2]) => {
					if (n1 > n2) {
						return 1
					} else if (n1 == n2) {
						return 0
					} else {
						return -1
					}
				})
				return ['US'].concat(c.map(([code]) => code))
			},
			country: function () {
				return this.countries[this.countryCode] || 'No country selected';
			},
			productData: function () {
				return JSON.parse(this.productDataJson)
			},
			productsLink: function () {
					return "/products"
			},
			styles: function () {
				if (this.isOpen) {
					return 'right: 0;';
				} else {
					return 'right: -120%;';
				}
			},
			bvModalStyles: function () {
				if (this.bvModalIsOpen) {
					return 'display: none;';
				} else {
					return 'display: block;';
				}
			},
			currencySymbolLeft: function () {
				if (!euHempCountries[this.countryCode] && !currencySymbols.left[this.countryCode] && !currencySymbols.right[this.countryCode]) {
					return currencySymbols.left.US
				} else {
					return currencySymbols.left[this.countryCode]
				}
			},
         minusCurrencySymbolLeft: function () {
            if (!euHempCountries[this.countryCode] && !currencySymbols.left[this.countryCode] && !currencySymbols.right[this.countryCode]) {
               return "-" + currencySymbols.left.US
            } else {
               return "-" + currencySymbols.left[this.countryCode]
            }
         },
			currencySymbolRight: function () {
				if (euHempCountries[this.countryCode] && this.countryCode != 'GB') {
					return currencySymbols.right.EU
				} else {
					return currencySymbols.right[this.countryCode]
				} 
			},
			productCount: function() {
				return this.products
					.filter(({free}) => !free)
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			},
			productFreeCount: function() {
				return this.products
					.filter(({isSpecialPackSubProduct: c}) => !c)
					.filter(({free}) => free)
					.reduce((a, {quantity}) => a + Number(quantity), 0)
			}
				// totalPrice: function () {
				//     return this.products.reduce((sum, i) => sum + i.quantity * i.price, 0)
				// },
				// totalBV: function () {
				//     return this.products.reduce((sum, i) => sum + i.quantity * i.bv, 0)
				// }
		},
		mounted: async function () {
			await this.getProducts()
			this.updateShoppingCartCount()
			var openCartBtn = document.getElementById('openCart')
				,openCartBtnMobile = document.getElementById('openCartMobile');

			let vm = this;


			openCartBtn.addEventListener("click", function () {
				vm.isOpen = true;
				vm.getProducts();
			});

			 openCartBtnMobile.addEventListener("click", function () {
			 	vm.isOpen = true;
			 	vm.getProducts();
			 });
                        console.log("in created",this.openCartInitially)
                        if (this.openCartInitially && !this.isOpen) {
                           document.getElementById("openCart").click()
                           console.log("cart should be opening")
                        }
		}
    }

</script>

<style>
	.active {
		color: red;
		right: 0;
	}
	.flex-column {
		display: flex;
		flex-direction: column;
	}
	.space-between {
		justify-content: space-between;
	}
	.parent-height {
		max-height: 100%;
	}
	.fill {
		flex: 1;
	}
</style>
